import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Paper, TextField, Typography, } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { ButtonLoader } from "frontend/src/ui/button-loader";
var useStyles = makeStyles({
    iconButton: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
    },
});
export var Form = function (_a) {
    var artist = _a.artist, title = _a.title, client = _a.client, 
    // published,
    // type,
    handlers = _a.handlers;
    var ref = React.createRef();
    // const duration = usePlaylistDuration(entries.tracks);
    // const genres = usePlaylistGenres(entries.tracks);
    var duration = "to:do";
    var genres = {};
    return (React.createElement("form", { onSubmit: handlers.submit.do },
        React.createElement(Box, { component: Paper, p: 2 },
            React.createElement(TextField, { label: "Исполнитель", value: artist.value, error: !!artist.error, helperText: artist.error, onChange: artist.onChange, fullWidth: true }),
            React.createElement(TextField, { label: "Название", value: title.value, error: !!title.error, helperText: title.error, onChange: title.onChange, fullWidth: true }),
            React.createElement(Box, { mt: 1, display: "flex", alignItems: "flex-end" },
                React.createElement(ButtonLoader, { variant: "contained", color: "primary", type: "submit", isLoading: handlers.submit.pending }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")),
            React.createElement(Box, { mt: 1 },
                React.createElement(Accordion, null,
                    React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMore, null) }, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"),
                    React.createElement(Box, { component: AccordionDetails, display: "flex", flexDirection: "column" },
                        React.createElement(Box, null,
                            React.createElement(Typography, { variant: "body2" }, "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C:"),
                            React.createElement(Typography, { variant: "h6", display: "inline" }, duration))))))));
};
